
import { PeriodHelper } from 'src/app/core/helpers/period.helper';
import moment from 'moment';

import { NewPeriodSelectorInterval } from 'src/app/core/enums/newPeriodSelectorInterval';
import { NewCalendarPeriodFilter } from 'src/app/core/models/period-selector/newCalendarPeriodFilter';
import { NewCalendarPeriodSelectorItem } from './base/new-calendar-period-selector-item';

export class QuarterPeriodSelectorItem extends NewCalendarPeriodSelectorItem {
    interval = NewPeriodSelectorInterval.Quarter;
    hasNavigation = true;

    constructor(name: string) {
        super(name);
    }

    getPeriodFilter = () => {
        let endDate: Date;
        const currentDate = moment().startOf('day').toDate();
        endDate = currentDate;
        const quarter = Math.floor(currentDate.getMonth() / 3);
        const startDate = new Date(currentDate.getFullYear(), quarter * 3, 1);
        endDate = moment(endDate).endOf('day').toDate();

        const periodFilter = new NewCalendarPeriodFilter();
        periodFilter.startDate = startDate;
        periodFilter.endDate = endDate;
        periodFilter.periodInterval = NewPeriodSelectorInterval.Quarter;

        return periodFilter;
    }

    getPreviousPeriodFilter = (currentFilter: NewCalendarPeriodFilter) => {
        let newStartDate;
        let newEndDate;
        ({ newStartDate, newEndDate } = PeriodHelper.getPreviousQuarterDates(currentFilter));

        const periodFilter = new NewCalendarPeriodFilter();
        periodFilter.startDate = newStartDate;
        periodFilter.endDate = newEndDate;
        periodFilter.periodInterval = NewPeriodSelectorInterval.Quarter;

        return periodFilter;
    }

    getNextPeriodFilter = (currentFilter: NewCalendarPeriodFilter) => {
        let newStartDate = moment(currentFilter.startDate).add(1, 'day').startOf('day').toDate();
        let newEndDate = moment(newStartDate).endOf('day').toDate();
        currentFilter.startDate = newStartDate;
        currentFilter.endDate = newEndDate;

        ({ newStartDate, newEndDate } = PeriodHelper.getNextQuarterDates(currentFilter));

        if (moment(newEndDate).endOf('day') > moment().endOf('day')) {
            newEndDate = moment().endOf('day').toDate();
        }

        const periodFilter = new NewCalendarPeriodFilter();
        periodFilter.startDate = newStartDate;
        periodFilter.endDate = newEndDate;
        periodFilter.periodInterval = NewPeriodSelectorInterval.Quarter;

        return periodFilter;
    }
}
